import React from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import logo from '../logo.svg';

function Layout() {
  return (
    <div className="App">
      <header className="App-header">
        <Link to="/" className="App-brand">
          <img src={logo} className="App-logo" alt="Dreamcode" />
          <span className="App-brand-name">Dreamcode</span>
        </Link>
        <nav className="App-nav">
          <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : undefined)}>
            Apps
          </NavLink>
          <NavLink to="/contact" className={({ isActive }) => (isActive ? 'active' : undefined)}>
            Contact
          </NavLink>
          <NavLink to="/privacy" className={({ isActive }) => (isActive ? 'active' : undefined)}>
            Privacy
          </NavLink>
        </nav>
      </header>
      <main className="App-main">
        <Outlet />
      </main>
      <footer className="App-footer">
        <Link to="/contact">Contact</Link>
        <span className="App-footer-sep">·</span>
        <Link to="/privacy">Privacy Policy</Link>
        <span className="App-footer-sep">·</span>
        <a
          href="https://buymeacoffee.com/dreamcode.app"
          target="_blank"
          rel="noopener noreferrer"
        >
          Buy Me a Coffee ☕
        </a>
      </footer>
    </div>
  );
}

export default Layout;
